module.exports = __webpack_public_path__ + "static/3-138f4dc122dcadaac94c6e48681f4167.jpeg";